// Mirror of NVOC.ApiHelpers.Models.Scorm.Questions.QuestionTypeEnum
export enum QuestionTypeEnum {
    UniqueChoice = 0,
    MultipleChoice = 1,
    TrueFalse = 2,
    Numeric = 3,
    FillIn = 4,
    LongFillIn = 5,
    Matching = 6,
    LongPerformance = 7,
    Sequencing = 8,
    RatingScalesSurveys = 9
}
